import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/calendar/")({
  component: RouteComponent,
});

function RouteComponent() {
  // Week is the primary planning surface everywhere: desktop gets the full
  // 7-day grid, phones an adaptive 3-day window (Buffer-style).
  return <Navigate to="/calendar/$view" params={{ view: "week" }} replace />;
}
